<template>
  <VPopover v-bind="vPopover_" :open="checked_" @hide="hide">
    <component
      :is="target_.component"
      :class="[
        ...theme_.target,
        ...((hasCheckedItems && theme_.targetActive) || []),
      ]"
      v-bind="target_.attrs || {}"
      @click="toggleDropdown"
    >
      <slot name="target">
        <AppSvgSymbol
          v-if="target_.leftIcon"
          :name="target_.leftIcon"
          :size="target_.leftIconSize || undefined"
          :type="target_.leftIconType || 'outline'"
        />
        <span v-if="target_.label" v-html="target_.label" />
        <AppSvgSymbol
          v-if="target_.icon"
          :name="target_.icon"
          :size="target_.iconSize || undefined"
          :type="target_.iconType || 'outline'"
        />
      </slot>
    </component>
    <template #popover>
      <slot name="popover">
        <div
          v-if="popover_.title || (items && items.length)"
          class="min-w-[240px] rounded-2xl p-2"
        >
          <div
            v-if="popover_.title || popover._closeButtonVisible"
            class="grid auto-cols-auto grid-flow-col items-center justify-between gap-4 p-2 text-base font-medium leading-6"
          >
            <span class="text-gray-900">
              {{ popover_.title }}
            </span>
            <button
              v-if="popover_.closeButtonVisible"
              class="text-gray-500 hover:text-gray-600 p-2 rounded-md"
              @click="toggleDropdown"
            >
              <AppSvgSymbol name="@escavador/x" size="18" />
            </button>
          </div>
          <slot name="list">
            <ul class="grid grid-flow-row gap-px bg-gray-200">
              <li
                v-for="item in items"
                :key="item.key || item.label"
                class="grid cursor-pointer auto-cols-min grid-flow-col items-center gap-4 whitespace-nowrap bg-white p-2 text-left text-sm font-medium leading-5 text-gray-500 hover:text-brand-blue-500"
                @click="select(item)"
              >
                <AppSvgSymbol
                  v-if="item.icon || mode === 'selection'"
                  :type="item.iconType || 'outline'"
                  :name="getIconName(item)"
                  :size="item.iconSize || undefined"
                />

                {{ item.label }}
              </li>
            </ul>
          </slot>
        </div>
      </slot>
    </template>
  </VPopover>
</template>
<script>
import AppSvgSymbol from "../AppSvgSymbol";

const THEME = {
  target: [
    "relative",
    "grid",
    "cursor-pointer",
    "grid-flow-col",
    "items-center",
    "gap-2.5",
    "rounded-md",
    "py-2.5",
    "px-3",
    "hover:bg-gray-50",
  ],
  targetActive: [
    "!bg-brand-blue-50",
    "!text-brand-blue-800",
    "hover:!text-brand-blue-900",
  ],
};

const TARGET = {
  label: "",
  icon: "@escavador/chevron-down",
  iconSize: 18,
  component: "button",
};

const VPOPOVER = {
  trigger: "manual",
  placement: "bottom-end",
  class: "grid text-gray hover:text-gray-600",
};

const POPOVER = {
  title: "",
  closeButtonVisible: false,
};

const BOTTOMSHEET = {
  multiple: false,
  allowEmptyFilter: true,
};

/**
 * AppDropdown é um wrapper do componente VPopover, do pacote v-toast
 * conigurado para exibir um dropdown que exibe uma lista de opções passadas via prop como um array de items, onde cada item deve ser um objeto no formato:
 *
 * {
 *  icon: ?String,
 *  label: String,
 *  iconSize: ?Number,
 *  key: ?String
 * }
 *
 *
 */
export default {
  name: "AppDropdown",
  props: {
    theme: {
      type: Object,
      default: () => ({}),
    },
    target: {
      type: Object,
      default: () => TARGET,
    },
    vPopover: {
      type: Object,
      default: () => VPOPOVER,
    },
    popover: {
      type: Object,
      default: () => POPOVER,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: "choose",
      validator: (item) => ["choose", "selection"].includes(item),
    },
  },
  components: {
    AppSvgSymbol,
  },
  emits: ["target-click", "show", "select", "hide"],
  data() {
    return {
      checked_: this.checked,
    };
  },
  computed: {
    theme_() {
      return {
        ...THEME,
        target: [...THEME.target, ...(this.theme.target || [])],
        targetActive: [
          ...THEME.targetActive,
          ...(this.theme.targetActive || []),
        ],
      };
    },
    hasCheckedItems() {
      return (
        this.items.filter((i) => i.checked).length || this.mode === "selection"
      );
    },
    target_() {
      return {
        ...TARGET,
        ...this.target,
      };
    },
    vPopover_() {
      return {
        ...VPOPOVER,
        ...this.vPopover,
      };
    },
    popover_() {
      return {
        ...POPOVER,
        ...this.popover,
      };
    },
    bottomSheetOptions_() {
      return {
        ...BOTTOMSHEET,
        ...this.bottomSheetOptions,
      };
    },
  },
  watch: {
    checked(updated) {
      if (!updated) {
        this.hide();
      }
    },
  },
  methods: {
    getIconName(item) {
      return (
        (this.mode === "selection" &&
          ((this.target_.label === item.label && "@escavador/check") ||
            "@escavador/empty")) ||
        item.icon
      );
    },
    toggleDropdown($event) {
      this.$emit("target-click", $event);
      this.checked_ ? this.hide() : this.show();
    },
    show() {
      this.checked_ = true;
      this.$emit("show");
    },
    select(item, $event) {
      if (
        (!item || item.closeOnClick === undefined || item.closeOnClick) &&
        this.closeOnSelect
      ) {
        this.hide();
      }

      this.$emit("select", item, $event);
    },
    hide() {
      this.checked_ = false;
      this.$emit("hide");
    },
  },
};
</script>
